import styled from "styled-components";

export const CardColored = styled.div`
  /* max-width: 270px; */
  padding: 6px 12px 5px;

  border-radius: 12px;
  color: white;
  /* width: 270px; */
  /* padding: 20px; */
  /* border-radius: 12px; */
  flex-basis: 30%;
  display: flex;
  /* align-items: center; */
  justify-content: space-evenly;
  flex-direction: column;
  /* height: 100%; */
  background-color: ${({ status }) => {
    switch (status) {
      case 0:
        return "#3278d7";
      case 1:
        return "#388ecd";
      case 2:
        return "#3da3c2";
      case 3:
        return "#43b9b8";
      case 4:
        return "#48cfad";
      case 5:
        return "#f6a742";
      case 10:
        return "#ed5565";

      default:
        return "gray";
    }
  }};

  .vehicle {
    border-radius: 8px;
    width: 246px;
    height: 30px;
    background-color: #f4f4f5;
    color: black;
    margin: auto;
  }

  .vehicle > span {
    vertical-align: sub;
  }
`;
